import type { ReactNode } from 'react';

interface Props {
  icon: ReactNode;
  title: string;
  titleId?: string;
  lede?: string;
  action?: ReactNode;
}

/** Derselbe Kopf für jeden Bereich des Portals: Symbol, Titel, eine Zeile Erklärung. */
export function SectionHeader({ icon, title, titleId, lede, action }: Props) {
  return (
    // Die Größe hängt am Bereich, nicht am Fenster: in der Admin-Vorschau (Telefonrahmen auf dem
    // Desktop) sähe der Kopf sonst aus wie am Desktop.
    <div className="@container flex items-center gap-3">
      <span
        aria-hidden
        className="bg-forest-soft text-accent rounded-guest-card @2xl:size-12 flex size-11 shrink-0 items-center justify-center"
      >
        {icon}
      </span>
      <div className="min-w-0 flex-1">
        <h2
          id={titleId}
          className="font-display text-fg @2xl:text-3xl text-2xl font-bold leading-tight tracking-[-0.02em]"
        >
          {title}
        </h2>
        {lede && <p className="text-fg-dim mt-0.5 text-sm">{lede}</p>}
      </div>
      {action}
    </div>
  );
}
